import {
  ActivityFilterKey,
  FeatureName,
  useActivityListFilter,
  useIsFeatureEnabled
} from '@gripp/shared-logic';
import {
  countFilters,
  FilterHeaders,
  useOpenedState
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { ActivityFilterModal } from './activityFilterModal';
import { ActivityFiltersOld } from './activityFilters-old';
import { ActivitySearchModal } from './activitySearchModal';

interface ActivityFiltersProps {
  assetId?: string;
}

export const ActivityFilters = ({ assetId }: ActivityFiltersProps) => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  if (!isCropCircleEnabled) {
    return <ActivityFiltersOld assetId={assetId} />;
  }
  return <ActivityFiltersBase assetId={assetId} />;
};

export const ActivityFiltersBase = ({ assetId }: ActivityFiltersProps) => {
  const filterKey = assetId
    ? ActivityFilterKey.AssetActivity
    : ActivityFilterKey.Activity;
  const { data: activityFilter } = useActivityListFilter(filterKey);
  const filterCount = countFilters(activityFilter);
  const { onOpen: onSearchOpen, onClose: onSearchClose, isOpened: isSearchOpened } = useOpenedState();
  const { onOpen: onFilterOpen, onClose: onFilterClose, isOpened: isFilterOpened } = useOpenedState();

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        onSearchPress={onSearchOpen}
        onFilterPress={onFilterOpen}
        filterCount={filterCount}
        Routes={{}}
      />
      
      <ActivitySearchModal
        isVisible={isSearchOpened}
        onDismiss={onSearchClose}
        filterKey={filterKey}
      />
      <ActivityFilterModal
        isVisible={isFilterOpened}
        onDismiss={onFilterClose}
        filterKey={filterKey}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
  searchButton: { padding: 8, borderRadius: 8 },
  filterButton: { padding: 8, borderRadius: 8 },
  filterButtonContent: { position: 'relative' },
  badgeContainer: { position: 'absolute', top: -6, right: -6 },
});
